
import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { getData, getHeaders } from '../../../http/request';
import { startOfDay, endOfDay, addDays, getYear, isValid } from 'date-fns';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';

export const REPORTS_ACTION_TYPES = {
	GET_DAILY_REPORTS_SUCCESS: 'GET_DAILY_REPORTS_SUCCESS',
    UPDATE_DAILY_REPORTS_PAGINATION: 'UPDATE_DAILY_REPORTS_PAGINATION',
    GET_DAILY_REPORTS_VALUES: 'GET_DAILY_REPORTS_VALUES',
    GET_WORKER_REPORTS_SUCCESS: 'GET_WORKER_REPORTS_SUCCESS',
    UPDATE_WORKER_REPORTS_PAGINATION: 'UPDATE_WORKER_REPORTS_PAGINATION',
    GET_YEARLY_REPORTS_SUCCESS: 'GET_YEARLY_REPORTS_SUCCESS'
};

const APPOINTMENTS_URL = `${ENTRYPOINT}${API_ROUTES.APPOINTMENTS}`;
const WORKER_REPORTS_URL = `${ENTRYPOINT}${API_ROUTES.WORKER_REPORTS}`;
const APPOINTMENT_DAILY_REPORTS_VALUES_URL = `${ENTRYPOINT}${API_ROUTES.APPOINTMENT_REPORTS_VALUES}`;
const YEARLY_REPORTS_URL = `${ENTRYPOINT}${API_ROUTES.YEARLY_REPORTS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { isPayed, startDate, endDate, customer, worker, types } = filters;
    let filterParams = `${params ? `${params}&` : '?'}isPayed=${Boolean(isPayed)}&exists[customer]=true`;
    if (startDate && isValid(startDate)) {
        const date = startOfDay(startDate).toLocaleDateString();
        filterParams = `${filterParams}&startDate[after]=${date}`;
    }
    if (endDate && isValid(endDate)) {
        const date = endOfDay(addDays(endDate, 1)).toLocaleDateString();
        filterParams = `${filterParams}&endDate[before]=${date}`;
    }
    if (types) {
        const typeFilters = types.map(type => `&type=${type.id}`).join('');
        filterParams = `${filterParams}${typeFilters}`;
    }
    if (customer) {
        const { uuid: customer_uuid } = customer;
        filterParams = `${filterParams}&customer=${customer_uuid}`;
    }
    if (worker) {
        const { uuid: worker_uuid } = worker;
        filterParams = `${filterParams}&worker=${worker_uuid}`;
    }
    return filterParams;
}

const getWorkerReportsFilters = (params, filters = {}) => {
    const { year, types } = filters;
    let filterParams = params;
    if (year) {
        filterParams = `${filterParams}&year=${getYear(year)}`;
    }
    if (types) {
        const typeFilters = types.map(type => `&type=${type.id}`).join('');
        filterParams = `${filterParams}${typeFilters}`;
    }
    return filterParams
}

export const getAppointmentReportsValues = (filters) =>
    async (dispatch) => {
        const params = getFilterParams('', filters);
        const GET_APPOINTMENT_REPORTS_URL = `${APPOINTMENT_DAILY_REPORTS_VALUES_URL}${params}`;
        const response = await getData(GET_APPOINTMENT_REPORTS_URL);
        dispatch({ type: REPORTS_ACTION_TYPES.GET_DAILY_REPORTS_VALUES, payload: { values: response } });
    }

export const getAppointmentReports = (data = { page: 0, rowsPerPage: 10, filters: { } }) => (
    async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_APPOINTMENTS_URL = `${APPOINTMENTS_URL}${params}`;
        const response = await getData(GET_APPOINTMENTS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: REPORTS_ACTION_TYPES.GET_DAILY_REPORTS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: REPORTS_ACTION_TYPES.UPDATE_DAILY_REPORTS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
        dispatch(getAppointmentReportsValues(filters));
    }
);

export const getWorkerReports = (data = { page: 0, rowsPerPage: 10, filters: { } }) => (
    async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getWorkerReportsFilters(params, filters);
        const GET_WORKER_REPORTS_URL = `${WORKER_REPORTS_URL}${params}`;
        const response = await getData(GET_WORKER_REPORTS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: REPORTS_ACTION_TYPES.GET_WORKER_REPORTS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: REPORTS_ACTION_TYPES.UPDATE_WORKER_REPORTS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
        // dispatch(getAppointmentReportsValues(filters));
    }
);

export const getYearlyReports = () => (
    async (dispatch) => {
        const GET_YEARLY_REPORTS_URL = YEARLY_REPORTS_URL;
        const response = await getData(GET_YEARLY_REPORTS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: REPORTS_ACTION_TYPES.GET_YEARLY_REPORTS_SUCCESS, payload: response['hydra:member'] });
        // dispatch(getAppointmentReportsValues(filters));
    }
);

export const updateDailyReportsPagination = ({ rowsPerPage, page = 0, filters }) => (
    (dispatch) => {
        dispatch({ type: REPORTS_ACTION_TYPES.UPDATE_DAILY_REPORTS_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getAppointmentReports({ page, rowsPerPage, filters }));
    }
)

export const updateWorkerReportsPagination = ({ rowsPerPage, page = 0, filters }) => (
    (dispatch) => {
        dispatch({ type: REPORTS_ACTION_TYPES.UPDATE_WORKER_REPORTS_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getWorkerReports({ page, rowsPerPage, filters }));
    }
)
